// 热门吃瓜榜数据
export type HotItem = {
  rank: number;
  videoId: string;
  heat: string;
  trend: 'up' | 'down' | 'new' | 'flat';
};

export const hotList: HotItem[] = [
  { rank: 1, videoId: 'v1', heat: '386.4万', trend: 'up' },
  { rank: 2, videoId: 'v4', heat: '318.9万', trend: 'new' },
  { rank: 3, videoId: 'v9', heat: '287.2万', trend: 'up' },
  { rank: 4, videoId: 'v12', heat: '241.7万', trend: 'up' },
  { rank: 5, videoId: 'v2', heat: '203.5万', trend: 'down' },
  { rank: 6, videoId: 'v7', heat: '176.8万', trend: 'up' },
  { rank: 7, videoId: 'v5', heat: '152.3万', trend: 'flat' },
  { rank: 8, videoId: 'v3', heat: '128.9万', trend: 'down' },
];

export const trendMeta: Record<HotItem['trend'], { label: string; icon: string }> = {
  up: { label: '上升', icon: 'ri-arrow-up-line' },
  down: { label: '下降', icon: 'ri-arrow-down-line' },
  new: { label: '新上榜', icon: 'ri-flashlight-line' },
  flat: { label: '持平', icon: 'ri-subtract-line' },
};